import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Usefetchdata from "hooks/usefetchdata";
import useModal from "components/modal/useModal";
import { Logout } from "assets/icons";
import DropdownMenu from "components/DropdownMenu/DropdownMenu";

const NavbarDesktop = () => {
    const {userData} = Usefetchdata();
    const {toggle} = useModal();
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);
    
    // Calculer la position du dropdown
    useEffect(() => {
        if (isOpen && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + 4,
                right: window.innerWidth - rect.right
            });
        }
    }, [isOpen]);
    
    // Fermer le dropdown quand on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                triggerRef.current && 
                !triggerRef.current.contains(event.target) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    
    // Fonction pour obtenir les initiales
    const getInitials = () => {
        const firstname = userData?.firstname || '';
        const lastname = userData?.lastname || '';
        const firstInitial = firstname.charAt(0).toUpperCase();
        const lastInitial = lastname.charAt(0).toUpperCase();
        return firstInitial + lastInitial;
    };
    
    // Fonction pour mapper le rôle
    const getRoleName = () => {
        const role = userData?.role;
        const roleMap = {
            500: 'Admin',
            515: 'Alternant',
            525: 'Steeve'
        };
        return roleMap[role] || 'Utilisateur';
    };
    
    const handleLogout = (e) => {
        e.preventDefault();
        toggle('log_d_logout');
    };
    
    const dropdownItems = [
        {
            icon: Logout,
            label: 'Se déconnecter',
            onClick: handleLogout
        }
    ];
    
    return (
        <>
            <div 
                ref={triggerRef}
                className="relative flex items-center gap-3 cursor-pointer hover:bg-gray-100 rounded-lg px-2 py-1 transition-colors select-none"
                onClick={() => setIsOpen(!isOpen)}
            >
                {/* Initiales */}
                <div className="min-w-[40px] w-[40px] h-[40px] rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors">
                    <span className="text-sm font-medium text-gray-700">
                        {getInitials()}
                    </span>
                </div>
                {/* Informations utilisateur */}
                <div className="flex flex-col min-w-[120px]">
                    <span className="text-sm font-medium text-gray-700">
                        {userData?.firstname} {userData?.lastname}
                    </span>
                    <span className="text-xs text-gray-500">
                        {getRoleName()}
                    </span>
                </div>
            </div>
            
            {/* Dropdown menu - rendu via portal pour éviter les problèmes de z-index */}
            {isOpen && ReactDOM.createPortal(
                <div 
                    ref={dropdownRef}
                    className="fixed z-[99999]"
                    style={{ top: dropdownPosition.top, right: dropdownPosition.right }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <DropdownMenu items={dropdownItems} />
                </div>,
                document.body
            )}
        </>
    );
};

export default NavbarDesktop;